import service from '@/utils/server';

const modName='/recycling/order/approve/';
const downloadFileModeName = '/common/web/download/';

//查询方法
export const pageInfo = data => {
  console.log('pageInfo', '-----');
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};

//新增方法
export const saveData = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};
//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'initUpdate/' + data,
    method: 'post',
    data
  });
};
//修改方法
export const editData = data => {
  return service({
    url: modName + 'update',
    method: 'post',
    data
  });
};
//删除方法
export const deleteData = data => {
  return service({
    url: modName + 'delete/'+data.id,
    method: 'post',
    data
  });
};


//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

//基本信息
export const orderBasicDetailsInfo = data => {
  return service({
    url: modName + 'orderBasicDetailsInfo',
    method: 'post',
    data
  })
};

// 初始化订单数据
export const initOrderApprovedData = data => {
  return service({
    url: modName + 'initOrderApprovedData',
    method: 'post',
    data
  });
};

//文件下载
export const fileDownload = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: downloadFileModeName + 'file/'+data,
    method: 'post',
    data
  });
};

// 同意
export const approveAgree = data => {
  return service({
    url: modName + 'approveAgree',
    method: 'post',
    data
  });
};

// 批量同意
export const batchApproveAgree = data => {
  return service({
    url: modName + 'batchApproveAgree',
    method: 'post',
    data
  });
};

//拒绝
export const refuseApproved = data => {
  return service({
    url: modName + 'approveRefuse',
    method: 'post',
    data
  });
};
//dehire
export const dehire = data => {
  return service({
    url: modName + 'dehire',
    method: 'post',
    data
  });
};
//itr模版下载
export const templateItr = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'templateItr/' + data.templateName,
    method: 'post',
    data
  });
};

//文件上传路径
export const uploadUrl = () => {
  return `${process.env.BASE_URL}${modName}uploadOrderFile`;
};

// 导入ITR
export const uploadItr = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'uploadItr',
    method: 'post',
    data
  });
};

// 导入itr 导出导入结果
export const uploadItrResult = data => {
    let config = {
        timeout: 500000, // 请求超时时间
        responseType: "blob"
    };
    return service({
        ...config,
        url: modName + 'uploadItrResult',
        method: 'post',
        data
    });
};

// 导入订单[国内订单类型]
export const uploadDomesticOrder = data => {
  const config = {
    responseType: 'blob',
    timeout: 500000, // 请求超时时间
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  return service({
    ...config,
    url: modName + 'uploadDomesticOrder',
    method: 'post',
    data
  })
}

// 导入订单模板下载 [国内订单类型]
export const templateDomesticOrder = data => {
  const config = {
    responseType: 'blob'
  }
  return service({
    ...config,
    url: modName + 'templateDomesticOrder/' + data.templateName,
    method: 'post',
    data
  })
}

// 导入订单 导出导入结果 [国内订单类型]
export const uploadDomesticOrderResult = data => {
  const config = {
    timeout: 500000, // 请求超时时间
    responseType: 'blob'
  }
  return service({
    ...config,
    url: modName + 'uploadDomesticOrderResult',
    method: 'post',
    data
  })
}

// 导入订单 方法
export const uploadOrder = data => {
  const config = {
    responseType: 'blob',
    timeout: 500000, // 请求超时时间
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  return service({
    ...config,
    url: modName + 'uploadOrder',
    method: 'post',
    data
  })
}

// 导入订单模板下载
export const templateOrder = data => {
  const config = {
    responseType: 'blob'
  }
  return service({
    ...config,
    url: modName + 'templateOrder/' + data.templateName,
    method: 'post',
    data
  })
}

// 导入订单 导出导入结果
export const uploadOrderResult = data => {
  const config = {
    timeout: 500000, // 请求超时时间
    responseType: 'blob'
  }
  return service({
    ...config,
    url: modName + 'uploadOrderResult',
    method: 'post',
    data
  })
}

//查询产品列表
export const findListByCustomerAndSku = data => {
  return service({
    url: modName + 'findListByCustomerAndSku',
    method: 'post',
    data
  });
};

//Dehire模版下载
export const templateDehire = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'templateDehire/' + data.templateName,
    method: 'post',
    data
  });
};

// 导入Dehire
export const uploadDehire = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'uploadDehire',
    method: 'post',
    data
  });
};

// 导入Dehire 导出导入结果
export const uploadDehireResult = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'uploadDehireResult',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/recovery/approve/api/index.js